import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { ConsoleLayout } from './layouts/ConsoleLayout';
import { operatorNav } from './layouts/nav';
import { FieldLayout } from './layouts/FieldLayout';
import { RequireAuth } from './RequireAuth';
import { NotFoundPage } from './NotFoundPage';
import { HomeRedirect } from './HomeRedirect';
import { LoginPage } from '../features/auth/LoginPage';
import { TotpVerifyPage } from '../features/auth/TotpVerifyPage';
import { TotpEnrollPage } from '../features/auth/TotpEnrollPage';
import { RecoverPasswordPage } from '../features/auth/RecoverPasswordPage';
import { consolaQrRoutes } from './routes-consola-qr';
import { consolaEquipoRoutes, operadorRoutes, publicRoutes, terrenoRoutes } from './routes-equipo';

/** Rutas de la SPA: autenticación y públicas, consola del partner, app de terreno y operador. */
export const routes: RouteObject[] = [
  { path: '/', element: <HomeRedirect /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/login/verificar', element: <TotpVerifyPage /> },
  { path: '/login/recuperar', element: <RecoverPasswordPage /> },
  ...publicRoutes,
  {
    path: '/login/segundo-factor',
    element: <TotpEnrollPage />,
  },
  {
    path: '/consola',
    element: (
      <RequireAuth roles={['owner', 'admin', 'editor', 'viewer']}>
        <ConsoleLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="inventario" replace /> },
      ...consolaQrRoutes,
      ...consolaEquipoRoutes,
    ],
  },
  {
    path: '/terreno',
    element: (
      <RequireAuth roles={['seller', 'owner', 'admin']}>
        <FieldLayout />
      </RequireAuth>
    ),
    children: terrenoRoutes,
  },
  {
    path: '/operador',
    element: (
      <RequireAuth roles={['operator']}>
        <ConsoleLayout nav={operatorNav} area="Operador q-r.cl" />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="organizaciones" replace /> },
      ...operadorRoutes,
    ],
  },
  { path: '*', element: <NotFoundPage /> },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}
